import { Observable, ErrorSource, generateUUID, computeRawError, combine, } from '@openobserve/browser-core';
import { RumEventType } from '../../rawRumEvent.types';
import { trackConsoleError } from './trackConsoleError';
import { trackReportError } from './trackReportError';
export function startErrorCollection(lifeCycle, configuration, bufferedDataObservable) {
    const errorObservable = new Observable();
    bufferedDataObservable.subscribe((bufferedData) => {
        if (bufferedData.type === 0 /* BufferedDataType.RUNTIME_ERROR */) {
            errorObservable.notify(bufferedData.error);
        }
    });
    trackConsoleError(errorObservable);
    trackReportError(configuration, errorObservable);
    errorObservable.subscribe((error) => lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error }));
    return doStartErrorCollection(lifeCycle);
}
export function doStartErrorCollection(lifeCycle) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, ({ error }) => {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processError(error));
    });
    return {
        addError: ({ error, handlingStack, componentStack, startClocks, context }) => {
            const rawError = computeRawError({
                originalError: error,
                handlingStack,
                componentStack,
                startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: ErrorSource.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            rawError.context = combine(rawError.context, context);
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: rawError });
        },
    };
}
function processError(error) {
    const rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: generateUUID(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            component_stack: error.componentStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
            csp: error.csp,
        },
        type: RumEventType.ERROR,
        context: error.context,
    };
    const domainContext = {
        error: error.originalError,
        handlingStack: error.handlingStack,
    };
    return {
        rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext,
    };
}
//# sourceMappingURL=errorCollection.js.map